import React from "react";
import MainVannerCSS from "./product_dev.module.css";
import Product_youtube from "./Product_youtube";
import {Link} from 'react-router-dom'

function Product_dev() {
  return (
    <div className={MainVannerCSS.baseStart}>
      <img className={MainVannerCSS.back} src="img/en/product_top.png" alt="main" />    
      <Link
        to="/product3_en"
        style={{
          textDecoration: "none",
          color: "#ffffff",
        }}
      >
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link1}>
            <img src="img/btn_smartooth_on.png" alt="arrow" />
          </div>
        </div>
      </Link> 
      <Link
        to="/product2_en"
        style={{
          textDecoration: "none",
          color: "#ffffff",
        }}
      >
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link2}>
            <img src="img/btn_xylitol_off.png" alt="arrow" />
          </div>
        </div>
      </Link>         
      <img className={MainVannerCSS.back} src="img/en/product_1_1.png" alt="main" />          
      <Product_youtube />
    </div>    
  );
}
export default Product_dev;
